import { NotificationStateProps, notificationState } from '../../atoms/notificationAtom';
import React, { Fragment, useEffect, useState } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';

import { ReactComponent as ChevronLeftIcon } from '../../assets/chevron-left.svg';
import { NotificationResponse } from '../../models/NotificationResponse';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';
import { useNotificationFactory } from '../../factories/notificationFactory';
import { usePathNotification } from '../../hooks/notifications';
import { useSetRecoilState } from 'recoil';

export interface NotificationsListProps {
  items?: NotificationResponse[];
  isLoading?: boolean;
}
export default function NotificationsList({ items, isLoading }: NotificationsListProps) {
  const { mutateAsync: pathNotification } = usePathNotification();
  const setUiState = useSetRecoilState<UIStateProps>(uiState);
  const setNotifications = useSetRecoilState<NotificationStateProps>(notificationState);
  const [currentNotification, setCurrentNotification] = useState<NotificationResponse | null>(null);
  const notificationFactory = useNotificationFactory(currentNotification);

  useEffect(() => {
    if (currentNotification) {
      notificationFactory?.redirect();
    }
  }, [currentNotification, notificationFactory]);

  const handleClick = (notification: NotificationResponse) => {
    if (!notification.readAt) {
      pathNotification({
        id: notification.id,
        notification: { readAt: new Date() },
      })
        .then(() => {
          setNotifications((prevState) => ({
            ...prevState,
            items: prevState?.items?.map((item) =>
              item.id === notification.id ? { ...item, readAt: new Date() } : item
            ),
          }));
          setCurrentNotification(notification);
        })
        .catch(() => {
          setUiState((prev) => ({ ...prev, hasError: true }));
        });
    } else {
      setCurrentNotification(notification);
    }
  };
  return (
    <Fragment>
      {!isLoading ? (
        <ul className="notification-panel__list">
          {items?.map((notification) => (
            <li
              key={notification.id}
              onClick={() => handleClick(notification)}
              className={classNames('notification-panel__item', {
                'notification-panel__item--strong': !notification.readAt,
              })}
            >
              <div className="notification-panel__item__block">
                <h2 className="notification-panel__item__title">
                  {!notification.readAt && (
                    <span className="notification-panel__item__bullet"></span>
                  )}
                  {notification.title}
                </h2>
                <p className="notification-panel__item__content">{notification.content}</p>
              </div>

              <ChevronLeftIcon className="icon icon--action icon--primary" />
            </li>
          ))}
        </ul>
      ) : (
        <ul className="notification-panel__loading">
          {Array.from({ length: 5 }).map((_, index) => (
            <li key={index} className="notification-panel__item notification-panel__item--loading">
              <div>
                <Skeleton count={1} height={17} width="50%" className="mt-4 mb-2" />
                <Skeleton count={1} height={12} width="80%" />
              </div>
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
}
